var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRestartDbCircleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "17px",
    viewBox: "0 0 17 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_refresh") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Governance-dashboard",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Governance-dashboard---NEW-Copy-2",
    transform: "translate(-396.000000, -1001.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Data-Repositories",
    transform: "translate(320.000000, 765.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_refresh",
    transform: "translate(77.000000, 237.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5,0 C11.6443902,0 15,3.35560976 15,7.5 C15,11.6443902 11.6443902,15 7.5,15 C3.35560976,15 0,11.6443902 0,7.5 C0,3.35560976 3.35560976,0 7.5,0 Z",
    id: "Path-Copy-2",
    stroke: "#2C6BCC",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.951534,6.24537837 L11.112574,7.38633089 C11.0460441,7.47654359 10.9234333,7.50674795 10.8216473,7.45799877 L9.49174843,6.90257276 C9.43350712,6.88035967 9.38732013,6.83519804 9.36432863,6.7779817 C9.34133712,6.72076536 9.34362854,6.65668912 9.37065017,6.60120936 C9.39450166,6.54445679 9.44079276,6.49973173 9.49884595,6.47735047 C9.55689914,6.45496921 9.62170131,6.45686444 9.67830522,6.48259903 L10.5827237,6.85670532 C10.2400151,5.34594949 8.80179354,4.32878723 7.23956568,4.49230316 C5.67733782,4.6558191 4.48806044,5.94799755 4.4750805,7.49598274 C4.4827556,8.76433101 5.28874482,9.89470151 6.49709874,10.3317895 C7.70545264,10.7688776 9.06221501,10.4208217 9.90086417,9.45860738 C9.98582802,9.35966866 10.1360945,9.34731627 10.2365209,9.43101525 C10.2849457,9.47061855 10.3151893,9.52773462 10.3204551,9.58952752 C10.3257208,9.65132035 10.3055668,9.71260641 10.2645226,9.75961244 C9.20205221,10.9978646 7.41553881,11.3548446 5.94747544,10.6222421 C4.47941207,9.88963968 3.71427448,8.25931833 4.09854722,6.68262763 C4.48281996,5.10593694 5.91586462,3.99580141 7.56144953,4 C9.20994382,4.00022186 10.6435331,5.11357751 11.0289326,6.69294423 L11.5696927,5.96264862 C11.6149704,5.90017539 11.6878006,5.86276177 11.7657046,5.86195526 C11.8156816,5.86442439 11.8640542,5.88014767 11.9057131,5.90746435 C12.0105416,5.98953935 12.0309252,6.13852019 11.9518977,6.24502003 L11.951534,6.24537837 Z",
    id: "np_refresh_1829032_FFFFFF",
    stroke: "#006DC9",
    strokeWidth: 0.5,
    fill: "#006DC9",
    fillRule: "nonzero"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestartDbCircleIcon);
export default __webpack_public_path__ + "static/media/restart-db-circle-icon.86fb1653b98c1401da0d7915a97fd436.svg";
export { ForwardRef as ReactComponent };